import { styled } from "@creditas/stylitas";

const Container = styled.div`
  select {
    padding-left: 10px;
  }
`;

export default Container;
